import * as React from 'react'
import { queryNoTracking, update } from '../services/DataService'
import { accentUtils, t, showDialog } from '../services/HelperService'
import { AccentComboUnbound } from '../controls/unbound/AccentComboUnbound'
import { AccentDialog } from './AccentDialog'
import { useValidation } from '../controls/bound/AccentFormCtrl'
import { AccentSpinner } from '../controls/AccentSpinner'
import { AccentButton } from '../controls/AccentButton'



export function showDiscardWebLeadDlg(id) {

    return new Promise(p => {

        showDialog(<DiscardWebLeadDlg />).then(s => {

            if (!s.canceled) {
                update("DiscardLead", {
                    ID: id,
                    ReasonID: s.ReasonID,
                    ReasonNotes: s.ReasonNotes
                }).then(function () {
                    p();
                });
            } else {
                p();
            }        
        });
    });
}


export const DiscardWebLeadDlg = React.memo(props => {

    const [discardReason, setDiscardReason] = React.useState(null);
    const [discardNotes, setDiscardNotes] = React.useState(null);
    const [data, setData] = React.useState(null);

    const validation = useValidation("#snooze-lead-dlg");

    const onChanged = React.useCallback((e) => {
        setDiscardReason(e);
    }, [setDiscardReason]);

    const onNotesChanged = React.useCallback((e) => {
        setDiscardNotes(e.target.value);
    }, [setDiscardNotes]);

    const onClose = React.useCallback((e) => {
        props.onClose({ canceled: false, ReasonID: discardReason, ReasonNotes: discardNotes });
    }, [discardReason, discardNotes]);


    React.useEffect(() => {

        queryNoTracking('PL_LeadDiscardReasons').getAll({ includeID: null, activeOnly: true })
            .then(r => {
                setData(r);
            });

    }, []);




    if (accentUtils.isNull(data)) return <AccentSpinner />;

    const isValid = !accentUtils.isEmpty(discardReason) && validation.isValid;

    return <AccentDialog
        headerContent={t("application_strings.views.leads.leadGrid.discardDlgTitle")}
        onClose={props.onClose}
        actionsContent={[
            <AccentButton key="2" tagName="ptCloseBtn" disabled={!isValid} onClick={onClose}>{t("application_strings.application.buttons.discard")}</AccentButton>
        ]}
    >
        <div id="snooze-lead-dlg" className="center">
            <AccentComboUnbound required displayField="Description" valueField="ID" onChange={onChanged} label="application_strings.views.leads.leadGrid.discardReasonLabel" data={data} />
            <textarea style={{ marginTop: "20px" }} multiple onChange={onNotesChanged} placeholder="Enter reason notes here..." />
        </div>
    </AccentDialog>;

});